<template>
  <v-dialog :value="value" :width="500" scrollable @input="$emit('input', false)">
    <v-card>
      <v-card-title class="headline py-2">
        <div class="grow">
          {{ $t('Order Summary') }}
        </div>
        <v-btn flat icon left @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="member">
        <LivechatOrderSummary
          :key="timestamp"
          :page-id="selectedBot.pageid"
          :user-id="member.user_id"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import LivechatOrderSummary from '@/components/view/livechat/livechat-order-summary.vue'

export default {
  components: { LivechatOrderSummary },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    member: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      timestamp: Date.now()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    value(value) {
      if (value) {
        this.timestamp = Date.now()
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/Tremendous/UserOrderListDialog.vue